"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var AppConfig_1 = require("./AppConfig");
var Message = exports.Message = (function () {
    function Message() {
    }
    Message.log = function () {
        var logItems = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            logItems[_i] = arguments[_i];
        }
        if (AppConfig_1.AppConfig.APP_CONFIG.debugMode) {
            for (var i = 0; i < logItems.length; ++i) {
            }
        }
    };
    Message.lang = 'ja';
    Message.LOADING = {
        icon: 'hourglass half icon',
        title: {
            ja: '読み込み中...',
            en: 'Loading....',
        },
    };
    Message.LOAD_CONF_ERROR = {
        icon: 'exclamation circle',
        title: {
            ja: '設定データの読込に失敗しました',
            en: 'Failed to load Configs',
        },
    };
    Message.LOAD_DATA_ERROR = {
        icon: 'exclamation circle',
        title: {
            ja: '設定データの読込に失敗しました',
            en: 'Failed to load Configs',
        },
    };
    Message.init = function () {
        Message.messageWindow = $('#messageWindow');
    };
    Message.isLang = function (value) {
        return value === 'ja' || value === 'en';
    };
    Message.showMessage = function (mode) {
        Message.messageWindow.show();
        var lang = Message.lang;
        if (Message.isLang(lang) && mode.title[lang]) {
            Message.messageWindow.find('.header').text(mode.title[lang]);
        }
        if (mode.icon) {
            Message.messageWindow.find('#messageIcon').removeAttr('class').attr('class', mode.icon);
        }
    };
    Message.hideMessage = function () {
        Message.messageWindow.hide();
    };
    Message.MESSAGE_JA = {
        dialog: {
            LOAD: {
                USER_CONFIG: 'ユーザ設定を読込中...',
                SCREEN_CONFIG: '画面設定を読込中...',
                MESUREMENT_DATA: '計測データを読込中...',
                SCREEN_ASSET: '画面データを読込中...',
            },
            ERROR: {
                USER_CONFIG: 'ユーザ設定の読み込みに失敗しました',
            },
        },
    };
    return Message;
}());
